import React from 'react';
import { Icon } from '@/components/Icon';
import { Icons } from '@/assets';

export const IconButtonV2 = ({
  children,
  onClick,
  title,
  disabled,
  icon,
  isGray = true,
  noBorder = false,
}) => {
  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      title={title}
      className={`${
        noBorder ? 'border-none' : 'border-solid border border-gray-200'
      } p-2 w-8 h-8 flex items-center justify-center bg-transparent shadow-none  hover:bg-gray-100 rounded  cursor-pointer`}
      style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
      {icon ? (
        <span style={{ pointerEvents: 'none' }}>
          <Icon
            color={isGray && (disabled ? '#CACFD8' : '#444746')}
            src={Icons[icon]}
            width={16}
            height={16}
          />
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default IconButtonV2;
